<template>
  <base-material-card
    color="primary"
    icon="mdi-table-large"
    inline
    class="px-5 py-3"
  >
    <template v-slot:after-heading>
      <div class="display-1 font-weight-light">
        Campos de Linhas
      </div>
    </template>
    <v-container class="py-0">
      <v-row
        align="center"
        justify="start"
        class="mt-2"
      >
        <draggable v-bind="dragOptions" v-model="selected" handle="#dragHandle">
          <div
            v-for="(selection, i) in selections"
            :key="selection.text"          
            class="d-inline-flex shrink ma-1"
          >
            <v-chip
              :disabled="loading"
              color="grey lighten-3"
              close
              @click:close="selected.splice(i, 1)"
            >
              <div class="d-inline-flex">
                <v-icon id="dragHandle" class="mr-1" style="cursor: move;">
                  mdi-reorder-horizontal
                </v-icon>
                {{ selection.text | toUpperCase }}
              </div>
            </v-chip>
          </div>
        </draggable>
      </v-row>
      <v-row class="mt-n5">
        <v-col v-if="!allSelected" cols="12" md="4">
          <v-text-field
            ref="search"
            class="ml-n2"
            v-model="search"
            hide-details
            prepend-icon="mdi-magnify"
            label="Pesquisar campo"
            single-line
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col v-if="!allSelected" cols="12" md="5" class="ml-n3 mt-n5">
          <v-checkbox
            v-model="todosCheckbox"
            @change="todosOsCampos()"
          >        
            <template v-slot:label>
              <span class="black--text">Selecionar todos os campos</span>
            </template>
          </v-checkbox>
        </v-col>
      </v-row>
    </v-container>
    <div
      class="transitioncard mt-n5"
      :style="{'overflow': 'hidden', 'max-height': chipContainerHeight}"
    >
      <template v-for="item in categories">
        <v-chip
          outlined
          class="mr-1 mt-1"
          v-if="!selected.includes(item)"
          :key="item.key"
          :disabled="loading || todosCheckbox"
          @click="selected.push(item)"
        >
          {{ item.text | toUpperCase }}
        </v-chip>
      </template>
    </div>
    <div
      justify="center"
      align="center"
      class="mt-n3"
    >
      <v-btn
        v-if="chipContainerHeight != '100%' && items.length > 0"
        class="mt-2 mb-n3 ml-n7"
        icon
        color="gray"
        @click="chipContainerHeight = '100%'"
      >
        <v-icon>mdi-chevron-down</v-icon>
      </v-btn>
      <v-btn
        v-else-if="items.length > 0"
        class="mt-2 mb-n3 ml-n7"
        icon
        color="gray"
        @click="chipContainerHeight = '37px'"
      >
        <v-icon>mdi-chevron-up</v-icon>
      </v-btn>
    </div>
  </base-material-card>
</template>

<script>
  export default {
    components: {
      draggable: () => import('vuedraggable')
    },

    props: {
      items: {
        type: Array,
        default: ()=> []
      },
      consulta: {
        type: Object,
        default: ()=> {}
      },
    },

    data: () => ({
      loading: false,
      search: '',
      selected: [],
      todosCheckbox: false,
      chipContainerHeight: '37px',
    }),

    computed: {
      allSelected () {
        //return this.selected.length === this.items.length
        return false
      },
      categories () {
        const search = this.search.toLowerCase()

        if (!search) return this.items

        return this.items.filter(item => {
          const text = item.text.toLowerCase()
          return text.indexOf(search) > -1
        })
      },
      selections () {
        const selections = []

        for (const selection of this.selected) {
          selections.push(selection)
        }

        return selections
      },
      dragOptions() {
        return {
          animation: 250,
          ghostClass: "ghost"
        };
      }
    },

    methods: {
      getConsultaCampos () {
        if(Object.keys(this.consulta).length !== 0) {
          const campos = JSON.parse(this.consulta.estrutura_json).campos.filter(
            campo => !['SUM','AVG','MIN','MAX','COUNT_ALL'].includes(campo.funcao)
          );
          let selecionados = [];

          campos.forEach(campo => {
            this.items.forEach(item => {
              if(campo.campo == item.text) {
                selecionados.push(item);
              }
            });
          });

          if (
            selecionados.length === this.items.length &&
            selecionados.every((value, index) => value === this.items[index])
          ) {
            this.todosCheckbox = true;
          } else {
            this.selected = selecionados;
          }
        }
      },

      todosOsCampos () {
        this.selected = []
      },

      exportCampos () {
        if(this.todosCheckbox) {
          var categories = JSON.parse(JSON.stringify(this.categories));
          return categories;
        }

        var selected = JSON.parse(JSON.stringify(this.selected));
        return selected;
      },

      next () {
        this.loading = true

        setTimeout(() => {
          this.search = ''
          this.selected = []
          this.loading = false
        }, 2000)
      }
    },

    watch: {
      items() {
        this.selected = [];
        this.todosCheckbox = false;
        
        if(Object.keys(this.selected).length <= 1) {
          this.getConsultaCampos()
        }
      }
    }
  }
</script>

<style scoped>
  .transitioncard{
    transition: max-height 0.3s ease-in-out;
  }

  .ghost {
    opacity: 0.5;
  }
</style>